// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__xIe2G","file":"styles_file__3sDQB"};